import * as TYPES from './patient-actiontypes';
import { persistStateToSession, getStateFromSession } from '../../webstorage';

const LOCAL_STORAGE_KEY = 'user:patient:patientId';

export const initialState = {
  patientId: getStateFromSession(LOCAL_STORAGE_KEY, null),
  firstName: null,
  lastName: null,
  userId: null,
  hasLogin: null,
  homeFacilityId: null,
  dateOfBirth: null,
  emailAddress: null,
  address: {},
};

const patientReducer = (state = initialState, action) => {
  let newState;

  switch (action.type) {
    case TYPES.SET_PATIENT_DATA:
      newState = { ...action.state };
      persistStateToSession(LOCAL_STORAGE_KEY, newState.patientId);
      break;
    case TYPES.LOAD_PATIENT_ADDRESS_SUCCESS:
      newState = { ...state, address: action.address };
      break;
    default:
      newState = state;
  }

  return newState;
};

export default patientReducer;
